import { IWidgetDataValidateResp } from "@UI/Widgets/IWidgetDataValidateResp";
import { Plegma } from './Api';


// --------------------------------------------------------------------------------------------
export enum StateStatus {
    NoData,
    Valid,
    DataNotValid,
    JsonError
}

// --------------------------------------------------------------------------------------------

export enum WebThingPortType {
    Trigger,
    Data
}

// --------------------------------------------------------------------------------------------
export interface PlegmaKeys {
    NodeKey: string;
    PortKey: string;
    ThingKey: string;
}
// --------------------------------------------------------------------------------------------

export interface PortData {
    /**
     * Not to be used from the widget instance.
     * This field is used from the web node, in order to define if a port event should be sent through ws.
     */
    IsActive: boolean;

    /**
     * Initialized from widget at `initThing()`.
     * Null means no value.
     * Empty or anything else means it has value.
     * Although most widgets start with empty value, this will be changed in the future.
     */
    State: any;

    /**
     * Not to be used from the widget instance.
     * This field is used from the widget wrapper in order to implement the ports debug layer.
     */
    LastStateStatus: StateStatus;

    /**
     * Latest port event timestamp.
     */
    Timestamp?: number;

    /**
     * Version of the port
     */
    Version?: number;
}
// --------------------------------------------------------------------------------------------

export interface ReduxThingState {
    PortStates: { [key: string]: PortData };
    LastStateStatus?: StateStatus;
    Loading: boolean;
    Version: number;
}
// --------------------------------------------------------------------------------------------

export interface ReduxPortState {
    Things: { [key: string]: ReduxThingState };
}
// --------------------------------------------------------------------------------------------


export interface ReduxPayloadAction {
    ThingKey: string;
    PortKey: string;
    IsActive: boolean;
    State?: any;
    OrigState?: any;
    LastStateStatus?: StateStatus;
    Timestamp?: number;
    event?: Plegma.PortEvent;
}
// --------------------------------------------------------------------------------------------

export interface StatePayloadActionPort {
    ThingKey: string;
    PortKey: string;
    IsActive: boolean;
    State?: any;
    OrigState?: any;
    LastStateStatus?: StateStatus;
    Timestamp?: number;
}
// --------------------------------------------------------------------------------------------
export interface StatePayloadActionLoading {
    loading: boolean;
}
// --------------------------------------------------------------------------------------------
export type StatePayloadAction = StatePayloadActionPort | StatePayloadActionLoading;

// --------------------------------------------------------------------------------------------
export interface ReduxPayload {
    // Payload data
    Ports?: ReduxPayloadAction[];

    // Loading enable
    LoadingStates?: { thingKey: string, loading: boolean }[];
}
// --------------------------------------------------------------------------------------------

export class ReduxActions {
    public static OnActivePortKey = "OnActivePortKey";
    public static OnPortEvent = "OnPortEvent";
    public static AddPort = "AddPort";
    public static RemovePort = "RemovePort";
    public static OnLoadingStateEvent = "OnLoadingStateEvent";
}
// --------------------------------------------------------------------------------------------

export interface PortKeyEvents {
    ThingKey: string;
    PortKey: string;
    Func: (data: any) => any;
}
// --------------------------------------------------------------------------------------------

export interface DBGMsgsPortState {
    State: any;
    OrigState: any;
    ErrorMsg: string;
    DataValidation: IWidgetDataValidateResp;
    Timestamp: string;
}
// --------------------------------------------------------------------------------------------

export interface DBGMsgsPort {
    States: DBGMsgsPortState[];
    LastStateHaveErrors: boolean;
}
// --------------------------------------------------------------------------------------------

export interface DBGMsgsThing {
    Ports: { [key: string]: DBGMsgsPort }
}
// --------------------------------------------------------------------------------------------

export interface DBGMsgsRoot {
    Things: { [key: string]: DBGMsgsThing }
}
// --------------------------------------------------------------------------------------------

export enum WebNodeStatus {
    Init,
    Connected,
    Disconnected,
    Timeout
}
// ================================================================================================

export const enum WebThingKeys {
    UserEmailKey = "__user_email_key__",
    URLParamsKey = "__url_param_key__",
    BoardLanguageKey = "__board_language_key__",
    Location = "__location_key__",
    Cookie = "__cookie_key__",
    WidgetSettings = "__widget_settings__",
    ToolbarIconClick = "__toolbar_icon_clicked",
}

export function isWebThingKey(key: string) {
    if (key == WebThingKeys.URLParamsKey ||
        key == WebThingKeys.UserEmailKey ||
        key == WebThingKeys.BoardLanguageKey ||
        key == WebThingKeys.Location ||
        key == WebThingKeys.Cookie ||
        key == WebThingKeys.WidgetSettings)
        return true;
    return false;
}

// --------------------------------------------------------------------------------------------